<template>
  <div>
    <DefaultPage id="leadership">
      <div class="hero">
        <div class="hero__call">
          <h1 class="leadership-headline-top">Leadership is action</h1>
          <h2 class="leadership-headline-btm">Not Position</h2>
        </div>
        <img src="../assets/bg-poly.png" class="hero-shape" alt="shape"/>
        <video class="hero__vid" preload="auto" autoplay="true" loop="loop" muted="muted" volume="0">
          <source :src="`${baseUrl}gradient-vid.mp4`" type="video/mp4">
        </video>
      </div>
      <VisualDataSection id="board-of-directors"
                         titleLightOne="Our"
                         titleHeavyOne="Board"
                         titleLightTwo="of"
                         titleHeavyTwo="Directors"
      >
        <div class="grid-container">
          <div class="grid-x grid-margin-x align-center">
            <div class="cell medium-10">
              <div class="grid-container">
                <div class="grid-x grid-margin-x leadership-grid">
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Hugh Francis, III, MD</h4>
                      <h6>CHAIR OF THE BOARD</h6>
                      <p>General and Vascular Surgery</p>
                      <p>Memphis Surgery Associates PC</p>
                      <p>Memphis, Tennessee</p>
                      <p>Director Since 1997</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>John O. Lytle, MD</h4>
                      <h6>VICE CHAIR OF THE BOARD</h6>
                      <p>Orthopedic Surgery</p>
                      <p>South Arkansas Orthopaedic Center</p>
                      <p>Pine Bluff, Arkansas</p>
                      <p>Director Since 2006</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Katrina M. Hood, MD</h4>
                      <h6>SECRETARY OF SVMIC</h6>
                      <p>Pediatrics</p>
                      <p>Pediatric and Adolescent Associates PSC</p>
                      <p>Lexington, Kentucky</p>
                      <p>Director Since 2009</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Matthew L. Perkins, MD</h4>
                      <h6>TREASURER OF SVMIC</h6>
                      <p>Internal Medicine and Pediatrics</p>
                      <p>Tennessee Medicine and Pediatrics PC</p>
                      <p>Smyrna, Tennessee</p>
                      <p>Director Since 2008</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Brady W. Allen, MD</h4>
                      <p>Emergency Medicine</p>
                      <p>Ascension St. Thomas</p>
                      <p>Nashville, Tennessee</p>
                      <p>Director Since 2020</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Robert J. Berkompas, MD</h4>
                      <p>Internal Medicine</p>
                      <p>Saint Thomas Medical Group</p>
                      <p>Nashville, Tennessee</p>
                      <p>Director Since 2010</p>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Melanie B. Blake, MD</h4>
                      <p>Internal Medicine</p>
                      <p>CHI Memorial</p>
                      <p>Chattanooga, Tennessee</p>
                      <p>Director Since 2018</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Chad T. Couch, MD</h4>
                      <p>Urology</p>
                      <p>President, Northeast Market</p>
                      <p>CEO, Bristol Regional Medical Center</p>
                      <p>Bristol, Tennessee</p>
                      <p>Director Since 2008</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Wayne A. Hudec, MD</h4>
                      <p>General Surgery</p>
                      <p>Ozark Surgical Associates</p>
                      <p>Fayetteville, Arkansas</p>
                      <p>Director Since 2009</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>William I. Mariencheck, Jr., MD</h4>
                      <p>Pulmonary and Critical Care Medicine</p>
                      <p>Wake Forest University Health Sciences</p>
                      <p>Winston-Salem, North Carolina</p>
                      <p>Director Since 2012</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Raymond S. Martin, III, MD</h4>
                      <p>General and Vascular Surgery</p>
                      <p>Physician Director of Surgical Services</p>
                      <p>Ascension St. Thomas</p>
                      <p>Nashville, Tennessee</p>
                      <p>Director Since 1994</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Michael A. McAdoo, MD</h4>
                      <p>Family Medicine</p>
                      <p>Milan Medical Center PC</p>
                      <p>Milan, Tennessee</p>
                      <p>Director Since 2002</p>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Russell E. Miller, CAE</h4>
                      <p>Chief Executive Officer</p>
                      <p>Tennessee Medical Association</p>
                      <p>Nashville, Tennessee</p>
                      <p>Director Since 2013</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>John H. Mize, FCAS, MAAA</h4>
                      <p>President, Chief Executive Officer</p>
                      <p>SVMIC</p>
                      <p>Brentwood, Tennessee</p>
                      <p>Director Since 2013</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Elise E. Schriver, MD</h4>
                      <p>Pulmonary and Critical Care Medicine</p>
                      <p>University Pulmonary and Critical Care</p>
                      <p>Knoxville, Tennessee</p>
                      <p>Director Since 2002</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Jane M. Sneed, MD</h4>
                      <p>Pediatrics</p>
                      <p>The Children’s Clinic</p>
                      <p>Jonesboro, Arkansas</p>
                      <p>Director Since 2013</p>
                    </div>
                    <div class="leadership-grid__block__section bod-block caps-p">
                      <h4>Lisa J. Young, MD</h4>
                      <p>Invasive Cardiology</p>
                      <p>Sutherland Cardiology Clinic, Inc.</p>
                      <p>Germantown, Tennessee</p>
                      <p>Director Since 2013</p>
                    </div>
                  </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </VisualDataSection>
      <VisualDataSection id="officers"
                      titleLightOne="Our"
                      titleHeavyOne="Officers"
                      >
        <div class="grid-container">
          <div class="grid-x grid-margin-x align-center">
            <div class="cell medium-10">
              <div class="grid-container">
                <div class="grid-x grid-margin-x leadership-grid">
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Hugh Francis, III, MD</h4>
                      <h6>CHAIR OF THE BOARD</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>JOHN O. LYTLE, MD</h4>
                      <h6>VICE CHAIR OF THE BOARD</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Katrina M. Hood, MD</h4>
                      <h6>Secretary of SVMIC</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>MATTHEW L. PERKINS, MD</h4>
                      <h6>TREASURER OF SVMIC</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>JOHN H. MIZE, FCAS, MAAA</h4>
                      <h6>PRESIDENT AND CHIEF EXECUTIVE OFFICER</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Michael A. RICCIARDELLI, CPA</h4>
                      <h6>CHIEF FINANCIAL OFFICER</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>STEPHEN A. DICKENS, JD, FACMPE</h4>
                      <h6>VICE PRESIDENT,</h6>
                      <h6>MEDICAL PRACTICE SERVICES</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>SHERIE L. EDWARDS, JD, MBA</h4>
                      <h6>VICE PRESIDENT,</h6>
                      <h6>CORPORATE AND LEGAL</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>RAYMOND M. MEADOR, JR., MBA</h4>
                      <h6>VICE PRESIDENT,</h6>
                      <h6>BUSINESS DEVELOPMENT</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>KENNETH W. RUCKER, JD</h4>
                      <h6>VICE PRESIDENT,</h6>
                      <h6>CLAIMS</h6>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section officer-block">
                      <h4>D. Mart Sesler</h4>
                      <h6>Vice President,</h6>
                      <h6>Information Systems</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Charmy M. Shrode</h4>
                      <h6>VICE President,</h6>
                      <h6>Underwriting</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>ROCHELLE E. WEATHERLY, JD</h4>
                      <h6>VICE PRESIDENT,</h6>
                      <h6>RISK EDUCATION AND EVALUATION SERVICES</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>JACKIE P. BOSWELL, MBA, FACMPE</h4>
                      <h6>ASSISTANT VICE PRESIDENT,</h6>
                      <h6>MEDICAL PRACTICE SERVICES</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>ROBIN BUTER, BSN, RN, CPHQ, LNCC</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Evaluation Services</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>KATHY CARTWRIGHT, BSN, RN, CPHQ, LNCC</h4>
                      <h6>ASSISTANT VICE PRESIDENT,</h6>
                      <h6>RISK ANALYTICS</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>DAN HIMMELBERG, JD</h4>
                      <h6>ASSISTANT VICE PRESIDENT,</h6>
                      <h6>CLAIMS</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>JULIE LOOMIS, RN, JD</h4>
                      <h6>ASSISTANT VICE PRESIDENT,</h6>
                      <h6>RISK EDUCATION PROGRAMMING AND DEVELOPMENT</h6>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 leadership-grid__block">
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Andy Meyers</h4>
                      <h6>Assistant Vice President,</h6>
                      <h6>Information Systems</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>JUDY MUSGROVE</h4>
                      <h6>ASSISTANT VICE PRESIDENT,</h6>
                      <h6>MARKETING AND COMMUNICATIONS</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>DEBORAH D. ROSE, RN, LNC</h4>
                      <h6>ASSISTANT VICE PRESIDENT,</h6>
                      <h6>MEDICAL INFORMATION SERVICES</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>ALISA S. WAMBLE, JD</h4>
                      <h6>ASSISTANT VICE PRESIDENT,</h6>
                      <h6>CLAIMS</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>TOM WERNER, FCAS, MAAA</h4>
                      <h6>ASSISTANT VICE PRESIDENT,</h6>
                      <h6>ACTUARIAL AND BUSINESS ANALYTICS</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>PATRICK MCBRIDE, CPA</h4>
                      <h6>DIRECTOR,</h6>
                      <h6>FINANCIAL REPORTING AND ASSISTANT CORPORATE SECRETARY</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>Jessica Elston</h4>
                      <h6>CONTROLLER</h6>
                    </div>
                    <div class="leadership-grid__block__section officer-block">
                      <h4>RENEE A. LEWIS</h4>
                      <h6>ASSISTANT CORPORATE SECRETARY AND ADMINISTRATOR, CLAIMS</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VisualDataSection>
      <VisualDataSection id="committees"
                      titleLightOne=""
                      titleHeavyOne="Committees"
                      titleLightTwo="of the"
                      titleHeavyTwo="Board"
                      >
        <div class="grid-container">
          <div class="grid-x grid-margin-x align-center">
            <div class="cell medium-10">
              <div class="grid-container">
                <div class="grid-x grid-margin-x committee-grid">
                  <div class="cell medium-6 large-4 committee-grid__block">
                    <div class="committee-grid__block__section">
                      <h3>Arkansas Advisory Committee</h3>
                      <p>Wayne A. Hudec, MD, Chair </p>
                      <p>John G. Elders, MD</p>
                      <p>Keitha D. Holland, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>Juan C. Roman, MD</p>
                      <p>Jane M. Sneed, MD </p>
                      <p>Dennis B. Yelvington, MD</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Audit Committee</h3>
                      <p>Katrina M. Hood, MD</p>
                      <p>Melanie B. Blake, MD</p>
                      <p>Michael A. McAdoo, MD</p>
                      <p>David A. Curbo, CPA *</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Budget Committee</h3>
                      <p>Raymond S. Martin, III, MD, Chair</p>
                      <p>Chad T. Couch, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>William I. Mariencheck, Jr., MD</p>
                      <p>Michael A. McAdoo, MD</p>
                      <p>Matthew L. Perkins, MD </p>
                      <p>Elise E. Schriver, MD</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Claims Management Core Committee</h3>
                      <p>Raymond S. Martin, III, MD, Chair</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>Elise E. Schriver, MD</p>
                    </div>
                  </div>
                  <div class="cell medium-6 large-4 committee-grid__block">
                    <div class="committee-grid__block__section">
                      <h3>Claims Management Committee Consultants</h3>
                      <p>R. Louis Adams, MD</p>
                      <p>Jon S. Cohen, MD</p>
                      <p>William H. Edwards, Jr., MD</p>
                      <p>Daniel S. Ely, MD</p>
                      <p>Keith L. Goldberg, MD</p>
                      <p>Brian M. Jerkins, MD</p>
                      <p>J. Louis Manning, MD</p>
                      <p>Robert H. Miller, II, MD</p>
                      <p>J. Philip Moyers, MD</p>
                      <p>Alan P. Mullins, MD</p>
                      <p>Frank J. Murabito, MD</p>
                      <p>David J. Soll, MD</p>
                      <p>Jane M. Thomas, MD</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Compensation Committee</h3>
                      <p>William I. Mariencheck, Jr., MD, Chair</p>
                      <p>Chad T. Couch, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>Raymond S. Martin, III, MD</p>
                      <p>Michael A. McAdoo, MD</p>
                      <p>Matthew L. Perkins, MD</p>
                      <p>Elise E. Schriver, MD</p>
                      <p>Kye Hudson *</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Executive Committee</h3>
                      <p>John O. Lytle, MD, Chair</p>
                      <p>Chad T. Couch, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>Katrina M. Hood, MD</p>
                      <p>Raymond S. Martin, III, MD</p>
                      <p>John H. Mize, FCAS, MAAA</p>
                      <p>Matthew L. Perkins, MD</p>
                      <p>Elise E. Schriver, MD</p>
                    </div>
                  <div class="committee-grid__block__section">
                      <h3>Investment Committee</h3>
                      <p>Matthew L. Perkins, MD, Chair</p>
                      <p>Chad T. Couch, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>William I. Mariencheck, Jr., MD</p>
                      <p>Raymond S. Martin, III, MD</p>
                      <p>Michael A. McAdoo, MD</p>
                      <p>Elise E. Schriver, MD</p>
                  </div>
                </div>
                  <div class="cell medium-6 large-4 committee-grid__block">
                    <div class="committee-grid__block__section">
                      <h3>RISK MANAGEMENT COMMITTEE</h3>
                      <p>Elise E. Schriver, MD, Chair </p>
                      <p>J. Michelle Allmon, MD </p>
                      <p>Michael S. Dolan, MD</p>
                      <p>Daniel S. Ely, MD</p>
                      <p>JimBob Faulk, MD</p>
                      <p>Scott R. Fowler, MD</p>
                      <p>Hugh Francis, III, MD </p>
                      <p>Katrina M. Hood, MD </p>
                      <p>Charles S. Joels, MD </p>
                      <p>John O. Lytle, MD</p>
                      <p>Douglas O. Olsen, MD </p>
                      <p>Antwan D. Robinson, MD</p>
                      <p>Matthew P. Willis, MD</p>
                  </div>
                    <div class="committee-grid__block__section">
                      <h3>Succession Planning Committee</h3>
                      <p>Hugh Francis, III, MD, Chair</p>
                      <p>John O. Lytle, MD</p>
                      <p>John H. Mize, FCAS, MAAA</p>
                      <p>Michael A. Ricciardelli, CPA</p>
                      <p>Elise E. Schriver, MD</p>
                      <p>Kye Hudson *</p>
                    </div>
                    <div class="committee-grid__block__section">
                      <h3>Underwriting Committee</h3>
                      <p>Chad T. Couch, MD, Chair</p>
                      <p>Brady W. Allen, MD</p>
                      <p>Robert J. Berkompas, MD</p>
                      <p>Mark E. Bigler, MD</p>
                      <p>Ravi D. Chauhan, MD</p>
                      <p>Anthony T. Everhart, MD</p>
                      <p>Hugh Francis, III, MD</p>
                      <p>Benjamin L. Huff, MD</p>
                      <p>Robert C. Hughes, MD</p>
                      <p>Shauna Lorenzo-Rivera, MD</p>
                      <p>John O. Lytle, MD</p>
                      <p>William I. Mariencheck, Jr., MD</p>
                      <p>Clinton A. Marlar, MD</p>
                      <p>Ryan D. Mire, MD</p>
                      <p>Craig A. Myers, MD</p>
                      <p>Matthew L. Perkins, MD</p>
                      <p>Jason A. Weaver, MD</p>
                      <p>Lisa J. Young, MD</p>
                    </div>
                  </div>
                </div>
                <p class="t-pad-30" style="font-size:12px;">* Non-Member Consultant</p>
              </div>
            </div>
          </div>
        </div>
      </VisualDataSection>
    </DefaultPage>
  </div>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import VisualDataSection from '@/components/section/VisualDataSection';

export default {
  name: 'Leadership',
  components: {
    VisualDataSection,
    DefaultPage
  },
  data () {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
